import React from 'react'
import config from '../../config.json'
import PageDashboardContent from './PageDashboardContent'
import WrapperPageSimple from '../WrapperPage/present/WrapperPageSimple'

const PageDashboard = () => (
    <WrapperPageSimple pageTitleTransId={config.routes.dashboard.transId} pageTitle={config.routes.dashboard.name}>
        <PageDashboardContent />
    </WrapperPageSimple>
)

export default PageDashboard